module.exports = __webpack_public_path__ + "5a13865d2bcaa01d31483c08c8903ea7.svg";